import { Grid, Paper, Stack, Typography, LinearProgress } from '@mui/material';

const MetricCard = ({ label, value, accent, helper }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      height: '100%',
      background: (theme) =>
        `linear-gradient(135deg, ${theme.palette.background.paper}, ${
          accent || theme.palette.primary.light
        })`,
      border: (theme) => `1px solid ${theme.palette.divider}`,
    }}
  >
    <Stack spacing={1}>
      <Typography variant="title" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="h5" color="text.primary" fontWeight={700}>
        {value}
      </Typography>
      {helper}
    </Stack>
  </Paper>
);

const MetricsBoard = ({ metrics, isLoading }) => {
  const readRate = Math.round((metrics?.read_ratio || 0) * 100);

  return (
    <Grid container spacing={0}>
      <Grid item xs={12} md={3}>
        <MetricCard label="Total enviadas" value={metrics?.total ?? 0} accent="rgba(195, 195, 195, 0.14)" />
      </Grid>
      <Grid item xs={12} md={3}>
        <MetricCard label="No leídas" value={metrics?.unread ?? 0} accent="rgba(195, 195, 195, 0.14)" />
      </Grid>
      <Grid item xs={12} md={3}>
        <MetricCard label="Leídas" value={metrics?.read ?? 0} accent="rgba(195, 195, 195, 0.14)" />
      </Grid>
      <Grid item xs={12} md={3}>
        <MetricCard
          label="Tasa de lectura"
          value={`${readRate}%`}
          accent="rgba(195, 195, 195, 0.14)"
          helper={
            <Stack spacing={0.5}>
              <LinearProgress
                variant={isLoading ? 'indeterminate' : 'determinate'}
                value={isLoading ? 0 : readRate}
                sx={{ height: 8, borderRadius: 4 }}
              />
              <Typography variant="title" color="text.secondary">
                {metrics?.read ?? 0} de {metrics?.total ?? 0} leídas
              </Typography>
            </Stack>
          }
        />
      </Grid>
    </Grid>
  );
};

export default MetricsBoard;
